import { AppSelect } from "components/antd-ui";
import { Staff } from "types/staff";
import "./StaffSelector.scss";

export type StaffSelectorMode = "single" | "multiple";

export interface StaffSelectorProps {
  value?: number | number[];
  onChange?: (value: number | number[] | undefined) => void;
  staffs: Staff[];
  mode?: StaffSelectorMode;
  disabled?: boolean;
  loading?: boolean;
  placeholder?: string;
  allowClear?: boolean;
}

export const StaffSelector = ({
  value,
  onChange,
  staffs,
  mode = "multiple",
  disabled,
  loading,
  placeholder = "Chọn nhân viên",
  allowClear = true,
}: StaffSelectorProps) => {
  const isMultiple = mode === "multiple";

  return (
    <AppSelect
      className="staffSelector"
      mode={isMultiple ? "multiple" : undefined}
      value={value}
      onChange={onChange}
      disabled={disabled}
      loading={loading}
      placeholder={placeholder}
      allowClear={allowClear}
      optionFilterProp="label"
      options={staffs.map((staff) => ({
        value: staff.id,
        label: staff.name || staff.username,
      }))}
      style={{ width: "100%" }}
    />
  );
};
